import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SettingService } from 'src/app/core/services/setting.service';
import { ToastService } from 'src/app/core/services/toast.service';
import { ConfirmModalService } from 'src/app/core/services/confirm-modal.service';
@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss'
})
export class SettingsComponent {

  isLoading: boolean = false;

  breadCrumbItems: Array<{}>;
  platformSubmitted: boolean = false;
  securitySubmitted: boolean = false;
  platformConfig: FormGroup;
  securityForm: FormGroup;
  ComplianceForm: FormGroup;

  constructor(private fb: FormBuilder, private toastService: ToastService, private settingsService: SettingService, private confirmModalService: ConfirmModalService) { }

  ngOnInit() {
    this.breadCrumbItems = [{ label: 'AVSS eSign' }, { label: 'Settings', active: true }];
    this.getSettingsData();
    this.platformConfig = this.fb.group({
      platformName: ['', Validators.required],
      supportEmail: ['', [
        Validators.required,
        Validators.email,
        this.noDoubleComValidator,
        Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-z0-9-]+\.(?!.*\.\1)([a-z]{2,})$/i)]],
      language: ['', [Validators.required]],
    });

    this.securityForm = this.fb.group({
      sessionTimeout: ['', [
        Validators.required,
        Validators.max(1440)]],
      passwordPolicy: ['Strong', Validators.required],
      require2FAForAdmins: [false],
    });

    this.ComplianceForm = this.fb.group({
      certInComplianceEnabled: [false],
      soc2AuditLogging: [false],
      gdprDataProtection: [false],
      iso27001ComplianceMode: [false],
    });
  }

  noDoubleComValidator(control: AbstractControl) {
    const email = control.value;
    if (!email) return null;

    // block .com.com
    if (email.toLowerCase().includes('.com.com')) {
      return { doubleCom: true };
    }

    return null;
  }
  getSettingsData() {
    this.isLoading = true;
    this.settingsService.getSettingData().subscribe({
    next: (res: any) => {
        this.isLoading = false;
        this.platformConfig.patchValue({
          platformName: res.platformName,
          supportEmail: res.supportEmail,
          language: res.language,
        });

        this.securityForm.patchValue({
          sessionTimeout: res.sessionTimeout,
          passwordPolicy: res.passwordPolicy,
          require2FAForAdmins: res.require2FAForAdmins,
        });

        this.ComplianceForm.patchValue({
          certInComplianceEnabled: res.certInComplianceEnabled,
          soc2AuditLogging: res.soc2AuditLogging,
          gdprDataProtection: res.gdprDataProtection,
          iso27001ComplianceMode: res.iso27001ComplianceMode,
        });
      },
      error: (err) => {

        this.isLoading = false;
      },
    });
  }


  get platformControls() {
    return this.platformConfig.controls;
  }
  get securityControls() {
    return this.securityForm.controls;
  }

  updatePlatformConfig() {
  this.platformSubmitted = true;

  if (this.platformConfig.invalid) {
    return;
  }

  this.confirmModalService.open(
    'Update Platform Settings',
    'Are you sure you want to save platform settings changes?',
    () => {
      this.confirmUpdatePlatformConfig();
    },
    'Save',
    'Cancel'
  );
}

confirmUpdatePlatformConfig() {
  this.isLoading = true;

  this.settingsService.updatePlatformConfig(this.platformConfig.value)
    .subscribe({
      next: () => {
        this.isLoading = false;
        this.getSettingsData();

        this.toastService.showToaster(
          'Profile Updated',
          'Profile updated successfully.',
          'success'
        );
      },
      error: (err) => {
        this.isLoading = false;
      }
    });
}


  updateSecurity() {
  this.securitySubmitted = true;

  if (this.securityForm.invalid) {
    return;
  }

  this.confirmModalService.open(
    'Update Security Settings',
    'Are you sure you want to save security settings changes?',
    () => {
      this.confirmUpdateSecurity();
    },
    'Save',
    'Cancel'
  );
}

confirmUpdateSecurity() {
  this.isLoading = true;

  this.settingsService.updateSecuritySettings(this.securityForm.value)
    .subscribe({
      next: () => {
        this.isLoading = false;
        this.getSettingsData();

        this.toastService.showToaster(
          'Security Updated',
          'Security settings updated successfully.',
          'success'
        );
      },
      error: (err) => {
        this.isLoading = false;
      }
    });
}


  updateComplianceSettings() {
  if (this.ComplianceForm.invalid) {
    this.toastService.showToaster(
      'Invalid Selection',
      'Please select at least one compliance option.',
      'info'
    );
    return;
  }

  this.confirmModalService.open(
    'Update Compliance Settings',
    'Are you sure you want to save compliance settings changes?',
    () => {
      this.confirmUpdateComplianceSettings();
    },
    'Save',
    'Cancel'
  );
}

confirmUpdateComplianceSettings() {
  this.isLoading = true;

  this.settingsService.updateComplianceSettings(this.ComplianceForm.value)
    .subscribe({
      next: () => {
        this.isLoading = false;
        this.getSettingsData();

        this.toastService.showToaster(
          'Compliance Updated',
          'Compliance settings saved successfully.',
          'success'
        );
      },
      error: (err) => {
        this.isLoading = false;
      }
    });
}

  preventInvalidInput(event: KeyboardEvent) {
    if (['e', 'E', '+', '-', '.'].includes(event.key)) {
      event.preventDefault();
    }
  }

}
